module.exports = __webpack_public_path__ + "img/09.4f8056ce.jpg";